import * as Moment from 'moment';
import { extendMoment } from 'moment-range';
import { DATE_FORMAT } from './constants';

const moment = extendMoment(Moment);

export const getAllDatesBetweenTwoDates = (
  fromDate: Moment.Moment,
  toDate: Moment.Moment
): Moment.Moment[] => {
  const fromDateFormatted = moment(fromDate.format(DATE_FORMAT), DATE_FORMAT);
  const toDateFormatted = moment(toDate.format(DATE_FORMAT), DATE_FORMAT);
  const range = moment.range(fromDateFormatted, toDateFormatted);
  return Array.from(range.by('day'));
};
